<template>
  <b-form-group
    label="İlçe"
    label-for="id_districts"
  >
    <v-select
      v-model="dataItem.id_districts"
      :options="districts"
      label="title"
      :reduce="item => item.id"
      placeholder="İlçe"
      :disabled="!dataItem.id_cities"
    />
  </b-form-group>
</template>

<script>
import {
  BFormGroup,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

export default {
  name: 'Districts',
  components: {
    BFormGroup,
    vSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    districts() {
      return this.$store.getters['districts/dataList']
    },
  },
}
</script>
